import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { templateTitle } from "@/config/seoTitleTemplates";
import { getCheapestInsights } from "@/lib/cheapestPrices.functions";

const Billigaste = lazy(() => import("@/pages/elbolag/Billigaste"));

const DESCRIPTION =
  "Vilket elbolag är billigast? Se preliminär topp 3 elbolag per elområde (SE1–SE4), billigaste elbolaget för villa och lägenhet – och jämför på din adress.";

export const Route = createFileRoute("/elbolag/billigaste")({
  loader: () => getCheapestInsights(),
  head: () => {
    const base = seoHead("/elbolag/billigaste", { description: DESCRIPTION });
    return {
      ...base,
      meta: [
        { title: templateTitle("/elbolag/billigaste", "") ?? "Billiga elbolag | Elmarknad.se" },
        ...(base.meta ?? []).filter((m) => !("title" in m)),
      ],
    };
  },
  component: BilligasteRoute,
});

function BilligasteRoute() {
  const insights = Route.useLoaderData();
  return <Billigaste insights={insights ?? null} />;
}
